module.exports = __webpack_public_path__ + "static/media/LCLCover.1aefa737.png";